import { useThemeStore } from '@core/theme/useThemeStore';
import { Colors } from '@core/config';

const CustomDateRangeStyle = () => {
  const theme = useThemeStore();

  return (
    <style>
      {`    
          /* Custom styling for the current day to match our theme */
          .custom-date-range .rdrDayToday .rdrDayNumber span::after {
            background: ${theme?.theme?.primaryBrandColor || Colors.LINK_BLUE} !important;
          }
          /* Custom hover styling to match our theme */
          .custom-date-range .rdrDay.rdrDayHovered {
            border: 1.5px solid ${theme?.theme?.primaryBrandColor || Colors.LINK_BLUE} !important;
            border-radius: 0.8rem !important;
          }
          /* Remove new range hover highlight styling */
          .custom-date-range .rdrDayStartPreview,
          .custom-date-range .rdrDayInPreview,
          .custom-date-range .rdrDayEndPreview {
            border: none !important;
            box-shadow: none !important;
            outline: none !important;
            background: none !important;
          }
      `}
    </style>
  );
};

export default CustomDateRangeStyle;
